import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import LocatorPlugin from '@/plugins/locator';

Vue.config.productionTip = false;

Vue.use(LocatorPlugin, {router});

// noinspection JSUnusedGlobalSymbols
new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
